import { TimeTuple } from './TimePicker.types'

export const prefixWithZero = (num: number) => (num < 10 ? `0${num}` : `${num}`)

export const formatFullTime = (timeTuple: TimeTuple) => `${prefixWithZero(timeTuple[0])}:${prefixWithZero(timeTuple[1])} ${timeTuple[2]}`
export const formatTime = (timeTuple: TimeTuple) => `${prefixWithZero(timeTuple[0])}:${prefixWithZero(timeTuple[1])}`
export const formatAMPM = (timeTuple: TimeTuple) => timeTuple[2]
